import { render, staticRenderFns } from "./AddOrderFulfillmentNote.vue?vue&type=template&id=73c3e67d&scoped=true&"
import script from "./AddOrderFulfillmentNote.vue?vue&type=script&lang=js&"
export * from "./AddOrderFulfillmentNote.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderFulfillmentNote.vue?vue&type=style&index=0&id=73c3e67d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-2f6a8101d6/2/home/apps/.yarn/berry/cache/vue-loader-npm-15.10.1-3a0b6c19d2-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c3e67d",
  null
  
)

export default component.exports